import React, { Component } from "react";
import "../../styling/shared/footer.css";
import logoLets from "../../assets/images/shared/lets-footer.png";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-6">
              <p className="footer__title">
                Vendas oficiais do AquaPark Mar de Minas
              </p>
              <div className="row mt-5 mb-5">
                <div className="col-6">
                  <a
                    href="https://lets.events/?utm_source=userlanding"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={logoLets} alt="" className="footer__logo" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/component/shared/footer.js